import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import {
  FRONTEND_CRASH_ALERT_CATEGORY,
  getSentryEnvironment,
  isSentryEnabled,
  sentryBeforeSend,
} from "@/lib/sentry";
import App from "./App.tsx";
import "./index.css";

if (isSentryEnabled()) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: getSentryEnvironment(),
    sendDefaultPii: true,
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    integrations: [
      Sentry.replayIntegration(),
      Sentry.browserTracingIntegration(),
    ],
    beforeSend: sentryBeforeSend,
  });
}

const app = <App />;

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    {isSentryEnabled() ? (
      <Sentry.ErrorBoundary
        fallback={<p>حدث خطأ غير متوقع</p>}
        beforeCapture={(scope) => {
          scope.setTag("alert.category", FRONTEND_CRASH_ALERT_CATEGORY);
          scope.setTag("error.boundary", "global");
        }}
      >
        {app}
      </Sentry.ErrorBoundary>
    ) : (
      app
    )}
  </StrictMode>,
);
